module.exports = __webpack_public_path__ + "img/denver-25.8e23b876.png";